export default theme => ({
  /// /////////// JSS POUR LES DEUX FORMATS //////////////
  name: {
    textTransform: 'uppercase'
  },
  quantite: {
    fontSize: theme.tailleMoyenTexte,
    fontWeight: theme.regular
  },
  lienProducteur: {
    marginTop: 10,
    fontWeight: theme.bold,
    fontSize: theme.taillePetitTexte,
    '& a': {
      color: theme.ficheProduit.producerColorMobile
    }
  },
  oeil: {
    margin: '0px 5px -6px 0px'
  },
  plusOffres: {
    fontWeight: theme.regular,
    fontSize: theme.taillePetitTexte,
    color: theme.lien,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  },
  noProductMessage: {
    textAlign: 'center',
    width: '100%'
  },
  unavailable: {
    fontWeight: theme.extraBold,
    color: theme.prix,
    fontSize: theme.tailleGrandTexte,
    textAlign: 'center',
    margin: '15px 0'
  },
  wrapper: {
    minHeight: theme.minHeight
  },
  carouselItemImg: {
    paddingTop: '454px',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white'
  },
  carousel: {
    height: 454
  },

  /// /////////// JSS MOBILE //////////////

  topBar: {
    marginBottom: 15
  },
  grid: {
    backgroundColor: 'white'
  },
  title: {
    marginTop: 0
  },
  imageContainer: {
    position: 'relative',
    marginTop: '15px'
  },
  image: {
    width: '100%'
  },
  map: {
    position: 'absolute',
    right: '15px',
    bottom: '-21px'
  },
  button: {
    textAlign: 'center',
    marginTop: '30px'
  },
  hr: {
    borderColor: theme.ficheProduit.hrColor,
    border: '1px solid'
  },
  breadcrumbMobile: {
    marginTop: 15
  },
  categoryColor: {
    color: theme.ficheProduit.categorieColorMobile,
    marginBottom: 15,
    '&:hover': {
      color: theme.ficheProduit.categorieHoverColorMobile
    }
  },

  /// //////////////////JSS DESKTOP///////////////////////
  ads: {
    backgroundColor: 'white',
    textAlign: 'center'
  },
  divBorderAF: {
    backgroundColor: '#F8AF08',
    padding: '15px 0'
  },
  divAF: {
    margin: '0 auto',
    paddingBottom: 15,
    backgroundColor: 'white'
  },
  vert: {
    color: theme.texteCategorie
  },
  categorie: {
    marginTop: '15px'
  },
  flexContainer: {
    padding: 0,
    margin: '0 -15px',
    listStyle: 'none',

    display: 'flex',

    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  },
  flexItem: {
    padding: '0px 15px',
    marginTop: 10,
    width: '25%'
  },
  hrTitle: {
    borderColor: theme.ficheProducteur.hrColor,
    border: '1px solid',
    marginTop: 0
  },
  breadcrumb: {
    marginTop: 15
  }
})
